import { EXAMPLE_PHOTO } from "@/constants/Images";
import { Modal } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";
interface IModal {
  show: boolean;
  onHide: () => void;
}
export default function UploadGuideModal({ show, onHide }: IModal) {
  const style = {
    fontFamily: "font-light",
  };
  return (
    <Modal show={show} onHide={onHide} centered style={style}>
      <Modal.Header className="bg-black relative justify-between px-4">
        <Modal.Title className="text-white">
          Upload Multiple photos Guide
        </Modal.Title>
        <IoMdClose
          className=" text-white w-10 h-10 cursor-pointer"
          onClick={onHide}
        />
      </Modal.Header>
      <Modal.Body className="bg-black p-4">
        <div className="flex flex-col gap-4 text-white mt-2">
          <p>
            Activate the switcher ONLY if the image contains watermarks.
            Processing them requires additional resources, so DON'T DO IT for
            non-watermarked images. If turned on, the Copyright credentials are
            mandatory. If one of the fields is unknown, input there
            'unavailable'.
          </p>
          <div className="flex flex-col gap-1 border-b border-gray-700 pb-2">
            <p>
              -Upload format:{" "}
              <span className="text-orange" style={{ fontSize: 16 }}>
                name_yyyy-mm-dd.extension
              </span>
            </p>
            <p>
              -Example:{" "}
              <span className="text-orange" style={{ fontSize: 16 }}>
                Brad Pitt_2020-01-01.jpg
              </span>
            </p>
          </div>
          <div className="flex flex-col gap-1 border-b border-gray-700 pb-2">
            <p>
              -Upload format with the same date:{" "}
              <span className="text-orange" style={{ fontSize: 16 }}>
                name_yyyy-mm-dd_order.extension
              </span>
            </p>
            <p>
              -Example:{" "}
              <span className="text-orange" style={{ fontSize: 16 }}>
                Brad Pitt_2020-01-01_1.jpg
              </span>
            </p>
          </div>
          <div className="flex flex-col gap-1">
            <p>
              -Upload format with watermark:{" "}
              <span className="text-orange" style={{ fontSize: 16 }}>
                name_yyyy-mm-dd&Copyright&Credit&Number.extension
              </span>
            </p>
            <p>
              -Example:{" "}
              <span className="text-orange" style={{ fontSize: 16 }}>
                Brad Pitt_2023-01-12&Getty images&Mike Marsland&1456060995.jpg
              </span>
            </p>
            <div className="flex gap-1">
              <div className="w-[200px] h-[280px] relative">
                <img src={EXAMPLE_PHOTO} className="w-full h-full" />
                <div className="h-1 w-12 bg-blue-600 bottom-0 left-2 absolute" />
                <div className="h-1 w-26 bg-green-600 bottom-[82px] left-[90px] absolute" />
                <div className="h-1 w-26 bg-red-600 bottom-[91px] left-[90px] absolute" />
              </div>

              <div className="flex flex-col gap-1 mt-2">
                <p>
                  Copyright:{" "}
                  <span className="text-red-600" style={{ fontSize: 16 }}>
                    Getty images
                  </span>
                </p>
                <p>
                  Credit:{" "}
                  <span className="text-green-600" style={{ fontSize: 16 }}>
                    Mike Marsland
                  </span>
                </p>
                <p>
                  Number:{" "}
                  <span className="text-blue-600" style={{ fontSize: 16 }}>
                    1456060995
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
